/* eslint-disable react-hooks/exhaustive-deps */
import LoadingContent from 'components/LoadingContent';
import { debounce } from 'lodash';
import React from 'react';
import { Card } from 'react-bootstrap';
import courseServices from 'services/courseServices';
import axios from 'axios';
import ScrollTo from 'react-scroll-into-view';
import { formatYearRange } from 'components/helper/helper';
import { buildCourseSuggestParams } from './courseSuggestParams';

type Props = {
  currentHighschool: any;
  onUpdateCourseTitle: (course: any) => void;
  searchKey: String;
  schoolYear?: String;
  disabled?: boolean;
};

const hasSchoolLookup = (params: { college_board_code?: string; school_name?: string; school_id?: string }) =>
  !!(params.college_board_code || params.school_name || params.school_id);

const SuggestCourse = (props: Props) => {
  const searchCtrl = React.useRef(new AbortController());
  const [listCourse, setListCourse] = React.useState<any[]>([]);
  const [notFoundCourse, setNotFoundCourse] = React.useState(false);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [params, setParams] = React.useState(() =>
    buildCourseSuggestParams(props.currentHighschool, '', props.schoolYear)
  );

  React.useEffect(() => {
    fetchCourse(params);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const fetchCourse = async (nextParams: any) => {
    setListCourse([]);
    searchCtrl.current.abort();
    searchCtrl.current = new AbortController();

    if (!hasSchoolLookup(nextParams)) {
      setNotFoundCourse(!!nextParams.course_title);
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const res = await courseServices.getCourseSuggestSignal(
        { ...nextParams, limit_item: 100 },
        searchCtrl.current
      );
      if (res.length) {
        setNotFoundCourse(false);
        setListCourse(res);
      } else {
        setListCourse([]);
        setNotFoundCourse(true);
      }
    } catch (error: any) {
      if (axios.isCancel(error)) {
      } else {
      }
    }
    setLoading(false);
  };

  const debounceFetch = React.useCallback(
    debounce((key) => setParams(key), 500),
    []
  );

  React.useEffect(() => {
    debounceFetch(
      buildCourseSuggestParams(props.currentHighschool, props.searchKey, props.schoolYear)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.currentHighschool?.id,
    props.currentHighschool?.college_board_code,
    props.currentHighschool?.school_name,
    props.currentHighschool?.uc_name,
    props.searchKey,
    props.schoolYear,
  ]);

  const handleUpdateCourseTitle = (course: any) => {
    course.course_title && props.onUpdateCourseTitle(course);
    setListCourse([]);
  };

  return (
    <div style={{ marginTop: '-12px' }}>
      {loading ? (
        <LoadingContent />
      ) : notFoundCourse ? (
        <div className="w-100 text-center">{`There are no suitable courses for the school year ${formatYearRange(props.schoolYear)}`}</div>
      ) : (
        <ScrollTo
          selector=".pointer"
          smooth
          style={{ maxHeight: '300px', overflowY: 'auto' }}
        >
          {
             listCourse.map((course, index) => (
              <Card
                className="border rounded pointer my-1 p-1 pt-2"
                key={index}
                onClick={() => handleUpdateCourseTitle(course)}
                style={{ opacity: props.disabled ? 0.5 : 1, cursor: props.disabled ? 'not-allowed' : 'pointer' }}
              >
                <div className="d-flex align-items-end position-relative">
                  <div className="mx-3 pb-2">{course?.course_title}</div>
                  <div className="text-field-light sized70 pb-2">{course?.course_length}</div>
                </div>
              </Card>
            ))
          }
        </ScrollTo>
       
      )}
    </div>
  );
};

export default SuggestCourse;
